export default {
  'tax.receipt.list.header.number': 'Number',
  'tax.receipt.list.header.serie': 'Serie',
  'tax.receipt.list.header.issueDate': 'Issue Date',
  'tax.receipt.list.header.receiver': 'Receiver',
  'tax.receipt.list.header.situation': 'Situation',
  'tax.receipt.list.searchBar.button': 'New Receipt',
  'tax.receipt.list.searchBar.filter.company': 'Select a company',
  'tax.receipt.list.searchBar.filter.type': 'Select a type',
  'tax.receipt.list.searchBar.filter.situation': 'Select a situation',
  'tax.receipt.list.searchBar.filter.issueDate': 'Issue date',
  'tax.receipt.general.form.company': 'Company',
  'tax.receipt.general.form.model': 'Model',
  'tax.receipt.general.form.serie': 'Serie',
  'tax.receipt.general.form.number': 'Number',
  'tax.receipt.general.form.taxKey': 'Tax Key',
  'tax.receipt.general.form.natureOfOperation': 'Nature of Operation',
  'tax.receipt.general.form.issuePurpose': 'Issue Purpose',
  'tax.receipt.general.form.situation': 'Situation',
  'tax.receipt.general.form.issueDate': 'Issue Date',
  'tax.receipt.general.form.docType': 'Document Type',
  'tax.receipt.general.form.finalCustomer': 'Final Customer',
  'tax.receipt.general.form.operationDestination': 'Operation Destination',
  'tax.receipt.general.form.date': 'Check-in/Check-out Date',
  'tax.receipt.general.form.issueType': 'Issue Type',
  'tax.receipt.general.form.presenceIndicator': 'Presence Indeicator',
  'tax.receipt.general.form.uf': 'UF',
  'tax.receipt.general.form.city': 'City',
  'tax.receipt.general.form.shippingICMS':
    'Shipping, expenses are included in the calculation base ICMS ST',
  'tax.receipt.general.form.shippingIPI':
    'Shipping, expenses are included in the calculation base IPI',
  'tax.receipt.receiver.form.receiverType': 'Receiver Type',
  'tax.receipt.receiver.form.registration': 'CPF/CNPJ',
  'tax.receipt.receiver.form.taxpayer': 'Tax Payer',
  'tax.receipt.receiver.form.customer': 'Customer',
  'tax.receipt.items.list.header.manufacturer': 'Manufacturer',
  'tax.receipt.items.list.header.description': 'Description',
  'tax.receipt.items.list.header.cfop': 'CFOP',
  'tax.receipt.items.list.header.ncm': 'NCM',
  'tax.receipt.items.list.header.quantity': 'Qty',
  'tax.receipt.items.list.header.price': 'Price',
  'tax.receipt.items.list.header.discount': 'Discount',
  'tax.receipt.items.list.header.total': 'Total',
  'tax.receipt.items.list.totals.items': 'Items',
  'tax.receipt.items.list.totals.insurance': 'Insurance',
  'tax.receipt.items.list.totals.shipping': 'Shipping',
  'tax.receipt.items.list.totals.expenses': 'Expenses',
  'tax.receipt.items.list.totals.discounts': 'Discounts',
  'tax.receipt.items.list.totals.total': 'Total',
  'tax.receipt.items.button': 'Add new Item',
  'tax.receipt.items.modal.title.part': 'Select a part',
  'tax.receipt.items.modal.title.service': 'Select a service',
  'tax.receipt.items.modal.list.header.sku': 'SKU',
  'tax.receipt.items.modal.list.header.description': 'Description',
  'tax.receipt.items.modal.list.action.button': 'Select',
  'tax.receipt.delivery.form.name': 'Full Name',
  'tax.receipt.delivery.form.type': 'Type',
  'tax.receipt.delivery.form.type.pf': 'Physical person',
  'tax.receipt.delivery.form.type.pj': 'Legal person',
  'tax.receipt.delivery.form.cpf': 'CPF',
  'tax.receipt.delivery.form.cnpj': 'CNPJ',
  'tax.receipt.delivery.form.registration': 'Registration',
  'tax.receipt.delivery.form.phone': 'Phone number',
  'tax.receipt.delivery.form.zipcode': 'Zip code',
  'tax.receipt.delivery.form.street': 'Street',
  'tax.receipt.delivery.form.number': 'Number',
  'tax.receipt.delivery.form.complement': 'Complement',
  'tax.receipt.delivery.form.district': 'District',
  'tax.receipt.delivery.form.city': 'City',
  'tax.receipt.delivery.form.uf': 'UF',
  'tax.receipt.taxes.form.icms': 'ICMS',
  'tax.receipt.taxes.form.icmsSt': 'ICMS ST',
  'tax.receipt.taxes.form.ipi': 'IPI',
  'tax.receipt.taxes.form.issqn': 'ISSQN',
  'tax.receipt.taxes.form.fcp': 'FCP',
  'tax.receipt.taxes.form.fcpSt': 'FCP ST',
  'tax.receipt.taxes.form.fcpStHold': 'FCP ST Hold',
  'tax.receipt.taxes.form.pis': 'PIS',
  'tax.receipt.taxes.form.pisSt': 'PIS ST',
  'tax.receipt.taxes.form.pisStHold': 'PIS ST Hold',
  'tax.receipt.taxes.form.cofins': 'COFINS',
  'tax.receipt.taxes.form.cofinsSt': 'COFINS ST',
  'tax.receipt.taxes.form.cofinsHold': 'COFINS Hold',
  'tax.receipt.transport.form.label.transport': 'Transport',
  'tax.receipt.transport.form.shippingCompany': 'Shipping Company',
  'tax.receipt.transport.form.shippingType': 'Shipping Type',
  'tax.receipt.transport.form.label.transportVehicle': 'Transport Vehicle',
  'tax.receipt.transport.form.plate': 'Plate',
  'tax.receipt.transport.form.uf': 'UF',
  'tax.receipt.transport.form.rntc': 'RNTC',
  'tax.receipt.transport.form.label.volumes': 'Volumes',
  'tax.receipt.transport.form.quantity': 'Quantity',
  'tax.receipt.transport.form.kind': 'Kind',
  'tax.receipt.transport.form.brand': 'Brand',
  'tax.receipt.transport.form.numbering': 'Numbering',
  'tax.receipt.transport.form.grossWeight': 'Gross Weight',
  'tax.receipt.transport.form.netWeight': 'Net Weight',
  'tax.receipt.payments.title.payments': 'Payments',
  'tax.receipt.payments.title.billingData': 'Billing Data',
  'tax.receipt.payments.button.new': 'New Payment',
  'tax.receipt.payments.button.newInstallment': 'New Installment',
  'tax.receipt.payments.button.multiInstallments': 'Multiple Installments',
  'tax.receipt.payments.list.header.paymentType': 'Payment type',
  'tax.receipt.payments.list.header.total': 'Total',
  'tax.receipt.payments.list.header.flagCard': 'Flag Card',
  'tax.receipt.payments.list.header.authorization': 'Authorization',
  'tax.receipt.payments.list.header.number': 'Installment Number',
  'tax.receipt.payments.list.header.dueDate': 'Installment Due Date',
  'tax.receipt.payments.list.header.value': 'Installment Value',
  'tax.receipt.payments.form.changeValue': 'Change Value',
  'tax.receipt.payments.form.installmentNumber': 'Installment Number',
  'tax.receipt.payments.form.originalValue': 'Original Value',
  'tax.receipt.payments.form.discountValue': 'Discount Value',
  'tax.receipt.payments.form.netValue': 'Net Value',
  'tax.receipt.payments.modal.title': 'Payments',
  'tax.receipt.payments.modal.form.paymentType': 'Payment Type',
  'tax.receipt.payments.modal.form.value': 'Value',
  'tax.receipt.payments.modal.form.integrationType': 'Integration Type',
  'tax.receipt.payments.modal.form.cnpj': 'CNPJ',
  'tax.receipt.payments.modal.form.flagCard': 'Flag Card',
  'tax.receipt.payments.modal.form.authorization': 'Authorization',
  'tax.receipt.payments.modal.form.cardAcquirer': 'Card Acquirer',
  'tax.receipt.payments.installments.modal.title': 'Billing Data',
  'tax.receipt.payments.installments.modal.form.installmentNumber':
    'Installment Number',
  'tax.receipt.payments.installments.modal.form.installmentQuantity':
    'Installment Quantity',
  'tax.receipt.payments.installments.modal.form.value': 'Installment Value',
  'tax.receipt.payments.installments.modal.form.dueDate':
    'Installment Due Date',
  'tax.receipt.additional.form.taxAdditionalData':
    'Additional information of interest to tax authorities',
  'tax.receipt.additional.form.taxpayerAdditionalData':
    'Additional information of interest to the taxpayer',
};
